export default "/icon-quickstart.svg";